_ = require 'underscore'

module.exports = (str) ->
  map = _.reduce(str.split(','), (map, actionEntry) ->
    [actionType, attr] = actionEntry.split(':')

    if attr?
      map[actionType] ?= []
      map[actionType].push(attr)
    else
      map[actionType] = true

    map

  , {})

  (action) ->
    entry = map[action.get('type')]
    if !entry?
      false
    else if entry == true
      true
    else
      # For actionTypes like updateCard:idList
      old = action.get('data').old
      old? && _.any entry, (attr) ->
        old.hasOwnProperty(attr)
